var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-row",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"point-img",attrs:{"src":_vm.image,"alt":_vm.title}}),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }